import { selectEditorSettingsColumnsOptions } from "../draft-selectors";
import { removeManyDatapointRequests, updateOrAddManyColumnOptionStates, updateOrAddManyColumnTemplates } from "../helpers";
import { ColumnOptionType } from "../types";
export const unapplyGroupingOnColumnsReducer = (state, action) => {
    if (!action?.payload) {
        return;
    }
    action.payload.forEach((c) => {
        if (c.hide && c.columnOptionType !== ColumnOptionType.GroupingColumn) {
            c.hide = false;
        }
    });
    const newColumnOptions = updateOrAddManyColumnOptionStates(state, action.payload);
    if (newColumnOptions) {
        updateOrAddManyColumnTemplates(state, newColumnOptions);
        const groupingDatapoints = state.editor.settings?.groupingOptionsDatapoints;
        const columnOptions = selectEditorSettingsColumnsOptions(state);
        const columnsToRemoveNames = columnOptions?.filter((c) => c !== undefined && !c.rowGroup && c.hide && groupingDatapoints?.some((d) => d.name === c.id))
            .map((c) => c.id);
        if (columnsToRemoveNames) {
            removeManyDatapointRequests(state, columnsToRemoveNames);
        }
    }
};
